import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import {
  GetTasksDataTableDocument,
  GetTasksDataTableQuery,
} from 'generated/resources/datatable.graphql'
import { TaskPageDocument, TasksValueObjectsTaskIdentifierEnum } from 'generated/resources/graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import { CardHeader } from 'modules/core/components/OldCard'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'
import CompleteTask from 'modules/tasks/components/TaskStatus/CompleteTask'
import { analyticsVariables } from 'modules/tasks/components/TasksList/components/TaskAnalytics/analyticsData'
import { TaskIdentifier } from 'modules/tasks/lib/task'

import { DeleteButton } from './DeleteButton'

export const DataTableActions = ({
  status,
  identifier,
  hideActions,
  employee,
  isExternalUser,
}: {
  status: string | null
  identifier?: TasksValueObjectsTaskIdentifierEnum
  employee?: Employee
  hideActions?: boolean
  isExternalUser: boolean
}) => {
  interface ActionsProps {
    employee: Employee
  }

  const {
    access: { id: accessId },
  } = useCurrentSession()
  const dataTable = useDataTable<GetTasksDataTableQuery>()
  const selectedTasks = [...dataTable.selectedRows].map((v) => Number(v))

  const disabled = !selectedTasks.length
  const refetchQueries = [
    { query: TaskPageDocument, variables: analyticsVariables(accessId) },
    { query: GetTasksDataTableDocument, variables: { ids: selectedTasks, identifier } },
  ]
  const markAsDone = status === 'all' || status !== 'completed'

  const EmployeeActions = ({ employee }: ActionsProps) => {
    const { navigation } = useNavigation()

    const navigate = useNavigate()
    const tasksNewRoute = navigation.employees.id.tasks.new.fullPath({ id: employee.id })

    const canManageTasks = employee.policy.can('manageTasks')

    return (
      <CardHeader.RightAction
        action={{
          show: canManageTasks && !isExternalUser,
          onClick: () => navigate(tasksNewRoute),
          label: i18n.t('tasks.actions.create'),
        }}
      />
    )
  }

  const TasksActions = () => {
    const { navigation } = useNavigation()
    const navigate = useNavigate()

    if (isExternalUser) return null
    return (
      <Button
        iconName="add"
        type="primary"
        onClick={() => navigate(navigation.tasks.new.fullPath())}
      >
        {i18n.t('tasks.actions.create')}
      </Button>
    )
  }

  const renderActions = () => {
    if (employee) {
      return <EmployeeActions employee={employee} />
    }
    return <TasksActions />
  }
  return (
    <>
      {hideActions ? null : renderActions()}

      <CompleteTask
        identifier={identifier || TaskIdentifier.Single}
        disabled={disabled}
        taskIds={selectedTasks}
        markAsDone={markAsDone}
        refetchQueries={refetchQueries}
      />
      {selectedTasks.length > 0 && (
        <DeleteButton ids={selectedTasks} refetchQueries={[GetTasksDataTableDocument]} />
      )}
    </>
  )
}
